import React from 'react';
import { useState } from 'react';
import { Bio } from './bio';
import { Interests } from './interests';
import { Education } from './education';

export function AboutMe() {
  const [tab, setTab] = useState('bio');

  return (
    <div className="content-wrapper">
      <div className="left-side-bar">
        <nav className="left-side-bar__nav">
          <div className="left-side-bar__title">personal-info</div>
          <ul>
            <li className="left-side-bar__bio" onClick={() => setTab('bio')}>
              bio
            </li>
            <li
              className="left-side-bar__interests"
              onClick={() => setTab('interests')}
            >
              interests
            </li>
            <li
              className="left-side-bar__education"
              onClick={() => setTab('education')}
            >
              education
            </li>
          </ul>
          <div className="left-side-bar__title">contacts</div>
          <ul>
            <li className="left-side-bar__mail">
              <a href="mailto:nicolasolenev@gmail.com">
                nicolasolenev@gmail.com
              </a>
            </li>
            <li className="left-side-bar__phone">
              <a href="tel:+375255138085">+375(25)513-80-85</a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="content">
        <div className="content__title">
          <div className="content__tab">
            {`personal-info/${tab}`}{' '}
            <span className="content__close-btn"></span>
          </div>
        </div>
        {tab === 'bio' ? (
          <Bio />
        ) : tab === 'interests' ? (
          <Interests />
        ) : tab === 'education' ? (
          <Education />
        ) : null}
      </div>
    </div>
  );
}
